import { Injectable, SecurityContext, ViewContainerRef } from '@angular/core';
import { SohoMessageService, SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
import { AppConstants, LMDialogButtonKey } from '@utils/index';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMViewExceptionDetailsComponent } from '@error/lm-view-exception-details.component';
import { AccessDeniedErrorComponent } from '@error/lm-access-denied-error.component';
import { Subject } from 'rxjs';
import { LMContextService } from '../lm-context.service';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class LMErrorUtilService {

  public accessDeniedError$: Subject<boolean>;
  private dialog: SohoModalDialogRef<any>;
  private buttons: Array<any>;

  constructor(
    private sohoMessageService: SohoMessageService,
    private sohoModalDialogService: SohoModalDialogService,
    private lmUniqueIdService: LMUniqueIdService,
    private lmContextService: LMContextService,
    private domSanitizer: DomSanitizer
  ) {
    this.accessDeniedError$ = new Subject<boolean>();
  }

  public handleError(message: string, details?: string, status?: string, statusText?: string): void {
    const error: LMError = { message, status, details, title: statusText };

    if (status && status === AppConstants.VIEW_EXCEPTION) {
      this.handleViewException(error);
    } else {
      this.handleUnexpectedError(error);
    }
  }

  public handleViewException(error: LMError, placeholder?: ViewContainerRef): void {
    const dialogId = 'Error';
    this.buttons = [
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          modal.close(true);
        }
      },
    ];
    error.message = this.domSanitizer.sanitize(SecurityContext.HTML, error.message);

    if (!error.details) {
      const title = error.title ? error.title : Soho.Locale.translate(dialogId);

      // TODO fix up localization
      this.sohoMessageService
        .error()
        .title(title)
        .message(error.message)
        .buttons(this.buttons)
        .open();
    } else {
      this.dialog = this.sohoModalDialogService
        .modal(LMViewExceptionDetailsComponent, placeholder, { fullsize: 'responsive' })
        .buttons(this.buttons)
        .cssClass('lm-modal-no-header')
        .title('')
        .apply((c) => {
          c.error = error;
        })
        .open();
    }
  }

  private handleOtherUnexpectedError(error: LMError): void {
    const dialogId = 'SystemError';
    this.buttons = [
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          modal.close(true);
        }
      },
    ];
    let message = error.message;
    if (error.details) {
      message = error.message + '<br/><br/>' + error.details;
    }
    // If response status is set to internal error, JSON error object is available in response body.
    // Instead set the response status to OK. The body need not be parsed.
    /*else if (error._body) {
      let messageBody = JSON.parse(error._body);
      message = messageBody.message + ((messageBody.details) ? '<br/>' + messageBody.details : '')
    }*/

    // LMCLIENT-30469: changed to match 3.5
    const title = Soho.Locale.translate('UnexpectedErrorOccured');
    // if (error.title) {
    //   title = error.title;
    // }

    // TODO fix up localization
    this.sohoMessageService
      .error()
      .title(title)
      .message(message)
      .buttons(this.buttons)
      .open();
  }

  public handleUnexpectedError(error: any, placeholder?: ViewContainerRef): void {
    // this.lmLoggerService.trace(error);
    if (error.status === 403) {
      // Access Denied exception. Emit event to show the error.
      this.showAccessDeniedError(error.error, placeholder);
    } else {
      const error2: LMError = {
        message: error.message,
        status:  error.status,
        title:   error.title,
        details: error.details ? error.details : error.stack
      };
      this.handleOtherUnexpectedError(error2);
    }
  }

  public showAccessDeniedError(error: any, placeholder?: ViewContainerRef) {
    let dlgComponent: AccessDeniedErrorComponent;
    const dialogId = (this.lmContextService.inMingleInbox()) ? 'ChooseAnApp' : 'AccessDenied';
    this.dialog = this.sohoModalDialogService
      .modal(AccessDeniedErrorComponent, placeholder, { fullsize: 'responsive' })
      .buttons([
        {
          id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.SIGNOUT ]),
          text:  Soho.Locale.translate(LMDialogButtonKey.SIGNOUT),
          click: () => {
            window.location.href = dlgComponent.signOutUrl;
          }
        }
      ])
      .title(Soho.Locale.translate(dialogId))
      .apply((accessDenied: AccessDeniedErrorComponent) => {
        dlgComponent = accessDenied;
      })
      .open();

    const accessDeniedError = this.accessDeniedError$.subscribe((appClicked: boolean) => {
      if (appClicked) {
        this.dialog.close();
        this.accessDeniedError$.complete();
        // this._loadMenu(this.lmUrlUtilService.getBannerSpecUrl());
      }
    });

    // this.subscriptionArray.push(accessDeniedError);
  }
}
//
